import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getLocalizedCountryFromCurrency} from "../../utils"
import cloneDeep from 'lodash/cloneDeep';
import Form from 'react-bootstrap/Form';
import FormFileUpload from "./../inputs/fileupload";
import { toast } from "react-toastify";

const RatesAdmin = () => {

    let navigate = useNavigate();
    const { usersAdminStore, loginStore, templatesStore, rateStore, utilsStore }= useStores();
    const { getAllUsers, users, rates, getAll, remove, duplicate, getAllWithOptions/*, setConfig, config*/, upload } = rateStore;
    const { getCountryCurrencies, countryCurrencies } = utilsStore;    
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        Promise.all([getCountryCurrencies()]);
    }, []);
    /*useEffect(() => {
        setIsLoading(true);
        async function fetchMyAPI() {
            getAll().then(() => {
                setIsLoading(false);
            });
        }

        fetchMyAPI();
    }, [getAll]);*/
    /**useEffect(() => {
        alert(templates?.results?.length?.toString())
    }, [templates?.results])*/

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                /*if (["workUnit", "billingUnit", "salaryUnit"].indexOf(f.field) > -1) {
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }*/

            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    const [validated, setValidated] = useState(false);
    const handleUpload = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {            
            var files = new FormData(event.target)?.getAll("file") ?? [];
            var data = new FormData();

            if (files && files?.length) {
                files?.forEach((f, i) => {
                    data.append(`file`, files[i])
                })
            }          
            
            upload(data).then(() => {
                setValidated(false);
                handleClose();
                tableRef?.current?.resetPage();                
            });
        }
        setValidated(true);
    }
    return (
        <span>
            <Modal show={show} onHide={() => { setValidated(false); handleClose() }}>
                <Form noValidate validated={validated} onSubmit={handleUpload}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("xmlUpload")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack gap={2}>
                            <FormFileUpload required label={t("files")} id="file" isLoading={isLoading} innerText={t("noFiles")} accept=".xml"/>
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                            {t("xmlUpdate")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        <ManagementTable name={t('rates')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("rates", "size"),
                dataState: getConfig("rates", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("rates", "size", c)}
            onDataStateChange={(c) => { setConfig("rates", "dataState", c) }}
            items={rates?.results} onPageChange={onPageChange} pageCount={rates?.pageCount} total={rates?.count} pageSize={rates?.pageSize} columns={
                [
                    //{ name: "period", prop: "name"},
                    { name: "period", prop: "period", fn: (v) => `${v?.split("-")?.[1]}.${v?.split("-")?.[0]}`, type: "month", filter: "date" },
                    { name: "currency", fn: (v) => `${v.code?.toUpperCase()} - ${getLocalizedCountryFromCurrency(v)}`, filterSelectOptions: countryCurrencies?.map((x) => ({ value: x.id.toString(), text: `${x.code?.toUpperCase()} - ${getLocalizedCountryFromCurrency(x)}` })) },                                        
                    { name: "quantity", filter: "numeric", useFormat: {decimals:0} },
                    { name: "rate", filter: "numeric", useFormat: { decimals: 4 } },
                    
                ]}
            actions={
                [
                    { text: t('xml'), icon: solid("upload"), onClick: (id) => handleShow() },
                ]
            }
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },                    
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
            />
        </span>

    );

   
};

export default observer(RatesAdmin);
